<template>
  <div
    class="v-select-wrap"
    tabindex="3"
    :class="{
      active: visible,
      top: pos === 'top',
      'has-desc': !!description
    }"
    @blur="closeSelect"
  >
    <div
      class="m-specifier-select"
      @click.stop.prevent="toggleSelect"
    >
      <div
        v-if="description"
        class="m-desc"
      >
        {{ description }}
      </div>
      <div class="m-value">
        <span class="m-text"> {{ value }} </span>
        <div class="select-icon-wrap">
          <i
            class="select-icon"
            :class="{
              up: pos === 'top',
              down: pos !== 'top'
            }"
          />
        </div>
      </div>
    </div>

    <div
      v-if="visible"
      class="v-select-scroll"
    >
      <div class="v-select">
        <template v-for="(item, index) in list">
          <VOption
            :key="index"
            :value="item"
            :class="[{
              active: value === item
            }]"
            @choose="e => onClickOption(e, index)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VOption from './VOption'

export default {
  name: 'VSelect',
  components: {
    VOption
  },
  model: {
    prop: 'value',
    event: 'select'
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: ''
    },
    // 自定义 desc
    description: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      // select 下拉框位置，默认向下展开，支持 'top' 向上展开
      pos: ''
    }
  },
  watch: {
    visible(val) {
      this.$emit('visible', val)
    }
  },
  methods: {
    onClickOption(value, index) {
      this.$emit('select', value)
      this.$emit('change', index)
      this.closeSelect()
    },
    closeSelect() {
      this.visible = false
      this.pos = ''
    },
    toggleSelect() {
      this.visible = !this.visible
      if (this.visible) {
        const rect = this.$el.getBoundingClientRect()
        if (document.documentElement.clientHeight - this.$el.offsetHeight - rect.top < 180) {
          this.pos = 'top'
        }
      } else {
        this.pos = ''
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.v-select-wrap {
  width: 100%;
  outline: none;

  &.has-desc {
    width: 100%;
    box-sizing: border-box;
    padding: 0 4px;

    .m-specifier-select {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .m-desc {
        flex: 1 1 auto;
        color: #b2b2b2;
        font-size: 12px;
      }
    }

    .m-value {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      text-align: right;
    }

    .select-icon-wrap {
      position: relative;

      .select-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -4px;
        margin-left: -4px;
      }
    }
  }

  .select-icon-wrap {
    display: inline-block;
    width: 16px;
    height: 16px;
  }

  .select-icon {
    .m-icon-trangle(4px;);

    &.down {
      &::before {
        border-top-color: @primary;
      }
    }

    &.up {
      &::before {
        border-bottom-color: @primary;
      }
    }
  }

  &.active {
    box-sizing: border-box;
    border: 1px solid #666;
    border-radius: 2px 2px 0 0;
    border-bottom: 0;
    line-height: 43px;
  }

  &.top {
    border: 1px solid #666;
    border-radius: 0 0 2px 2px;
    border-top: 0;

    .v-select-scroll {
      top: 0;
      border: 1px solid #666;
      border-bottom: 0;
      transform: translateY(-100%);
    }
  }
}

.v-select-scroll {
  position: absolute;
  z-index: 9;
  top: 43px;
  left: 0;
  width: 100%;
  max-height: 164px; // 注意用 px 参与计算
  box-sizing: border-box;
  border: 1px solid #666;
  border-top: 0;
  background: #333;
  overflow-y: auto;
  text-align: center;

  &::-webkit-scrollbar {
    width: 2px;
    height: 1px;
    appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 1px;
    background: rgba(256, 256, 256, 40%);
  }

  .v-select-option {
    height: 32px;
    color: #fff;
    font-size: 12px;
    line-height: 32px;

    &.active {
      color: @primary;
    }
  }
}
</style>
